import { MUSIC_VIDEO_ERROR_CODES, type BankFootageQuery } from 'fym-shared/src/music24/musicVideoApi';
import { musicVideoErrorCode, musicVideoErrorStatus } from '../doc/musicVideoErrors';
import { useMusicVideoEditor } from '../MusicVideoEditorContext';
import { useGetFootageBankQuery, useGetMusicVideoShowcaseBankQuery } from '../musicVideoEditorApi';

/** True for the 429 of the showcase bank search (design c4: "Search is busy"). Pure. */
export function isShowcaseSearchBusy(error: unknown): boolean {
  return musicVideoErrorStatus(error) === 429 || musicVideoErrorCode(error) === MUSIC_VIDEO_ERROR_CODES.rateLimited;
}

/**
 * A list of the bank: `GET /footage/bank` of the account, or in showcase mode the public search of
 * the showcase (`GET /public/music-video-showcase/bank`, 30 a minute). `isBusy` is the 429 of the
 * showcase search: the panel shows the busy line in place of the results.
 */
export function useBankSearch(query: BankFootageQuery, { skip = false }: { skip?: boolean } = {}) {
  const { mode, accountId } = useMusicVideoEditor();
  const isShowcase = mode === 'showcase';
  const { uuids: _uuids, ...search } = query;
  const account = useGetFootageBankQuery({ accountId, ...search }, { skip: skip || isShowcase });
  const showcase = useGetMusicVideoShowcaseBankQuery(search, { skip: skip || !isShowcase });
  const result = isShowcase ? showcase : account;
  return {
    data: result.data,
    isLoading: result.isLoading,
    error: result.error,
    isBusy: isShowcase && result.error !== undefined && isShowcaseSearchBusy(result.error),
    retry: () => {
      result.refetch().catch(console.error);
    },
  };
}
